import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/reset-password")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Nytt passord | VERQO" },
      { name: "description", content: "Velg et nytt passord for VERQO-kontoen din." },
      { property: "og:title", content: "Nytt passord | VERQO" },
      { property: "og:description", content: "Velg et nytt passord for VERQO-kontoen din." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ResetPassword,
});

function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (password.length < 8) {
      setError("Passordet må ha minst 8 tegn.");
      return;
    }
    setBusy(true);
    const { error: updateError } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (updateError) {
      setError(updateError.message);
      return;
    }
    navigate({ to: "/dashboard", replace: true });
  }

  return (
    <div className="min-h-screen grid place-items-center bg-surface p-6">
      <form onSubmit={onSubmit} className="card w-full max-w-sm p-8">
        <h1 className="text-lg font-semibold">Velg nytt passord</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Skriv inn et nytt passord for kontoen din.
        </p>

        <label className="mt-6 block text-sm font-medium" htmlFor="new-password">
          Nytt passord
        </label>
        <input
          id="new-password"
          type="password"
          className="input mt-2 w-full"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && <p className="mt-3 text-sm text-destructive">{error}</p>}

        <button type="submit" className="btn btn-primary mt-6 w-full" disabled={busy}>
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}
          Lagre nytt passord
        </button>
      </form>
    </div>
  );
}
